module.exports = __webpack_public_path__ + "img/Infografis_ID_05.fbba30e5.jpg";